import cx from "classnames";

import { StrapiImage, StrapiImageData } from "ui/StrapiImage";

import { SelectableCardProps, SelectableCard } from "./SelectableCard";

type PictureThumbnailExtraProps = {
  image?: StrapiImageData;
};

type PictureThumbnailProps = PictureThumbnailExtraProps & SelectableCardProps;

export const PictureThumbnail = ({
  image,
  ...props
}: PictureThumbnailProps) => (
  <SelectableCard className="w-18 h-18" {...props}>
    <StrapiImage
      size="thumbnail"
      sizes="(max-width: 1024px) 80vw, 33vw"
      image={image}
      className={cx(
        "w-20 h-20 translate-y-5",
        props.isDisabled && "opacity-50",
      )}
      loader
    />
  </SelectableCard>
);
